import React from 'react';
import { func, object, array } from 'prop-types';

import cx from 'clsx';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Close from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/styles';

import routes from 'commons/routes';
import { AppContext } from 'commons/contexts';
import { appSelectors, appActions } from 'commons/store/app';

import CollapsibleModule from './CollapsibleModule';

import styles from './styles';

export class Menu extends React.Component {
  static contextType = AppContext;

  static propTypes = {
    /* own props */
    onToggle: func.isRequired,
    /* app state */
    modules: array.isRequired,
    module: object.isRequired,
    application: object.isRequired,
    /* app actions */
    saveCurrentApplication: func.isRequired,
    /* material-ui styles */
    classes: object.isRequired,
    /* react-router */
    history: object.isRequired,
  };

  handleSelectApplication = (module, application) => {
    const { type, id } = application;

    this.setState({ expanded: false });
    this.props.saveCurrentApplication({ module, application });
    this.props.history.pushWithParams(routes.urls[type], { id });
  };

  renderToggleHeader = (classes, expanded) => (
    <div className={cx(classes.toggleMenu)}>
      <IconButton
        className={cx(classes.toggleButton, { expanded })}
        onClick={this.props.onToggle}
      >
        {!expanded ? <MenuIcon /> : <Close />}
      </IconButton>
    </div>
  );

  renderContent = () => {
    const { classes, modules, application, module } = this.props;
    const { expanded } = this.context;

    return (
      <div className={cx(classes.content, { expanded })}>
        {this.renderToggleHeader(classes, expanded)}
        {modules.map(item => (
          <CollapsibleModule
            key={item.id}
            module={item}
            application={application}
            activeModule={module.id}
            onSelect={this.handleSelectApplication}
          />
        ))}
      </div>
    );
  };

  render() {
    const { expanded } = this.context;

    return (
      <>
        {expanded && <div onClick={this.handleMenuClose} />}
        {this.renderContent()}
      </>
    );
  }
}

const mapStateToProps = state => {
  const {
    app: { module, application },
  } = state;

  return {
    modules: appSelectors.removeExternalModulesSelector(state),
    module,
    application,
  };
};

export default compose(
  withRouter,
  withStyles(styles),
  connect(
    mapStateToProps,
    { saveCurrentApplication: appActions.saveCurrentApplication }
  )
)(Menu);
